export enum RouteParamnames {
    token = 'token',
    via = 'via',
    id = 'id',
}
